<template>
  <header>
    <PartialsCommonHeader></PartialsCommonHeader>
  </header>
  <NuxtPage></NuxtPage>
  <footer>
    <LazyPartialsCommonFooter></LazyPartialsCommonFooter>
  </footer>
</template>
